const language: any = {
  send_image: "Send pictures",
  image: "Picture",
  send: "Send",
  cancel: "Cancel",
  service: "Customer Service",
  send_to: "Send to",
  reply: "reply",
  copy: "Copy",
  select_message: "Please select a message first",
  view_user: "View user information",
  merge_forward: "Merge forwarding",
  item_forwarding: "Forward one by one",
  delete: "delete",
  forward: "Forward",
  search: "search",
  chat_recently: "Recent Chats",
  friend: "Friends",
  affirm: "confirm",
  file: "document",
  chartlet: "Picture",
  remove_from_the_group: "You have been kicked out of the group chat",
  everyone_is_silent: "You have been banned or banned by everyone",
  system_error: "System Error",
  motion_graph: "Gif",
  chatting_records: "'s chat history",
  group_chatting_records: "'s group chat history",
  message_is_encrypted:
    "This message has been end-to-end encrypted. The web version cannot decrypt it. Please view it on your mobile phone.",
  month: "Month",
  day: "Day",
  message_does_not_support_viewing:
    "This message cannot be viewed. Please view the details on your mobile phone.",
  tips: "hint",
  cannot_be_longer_than_1000_characters:
    "The input content length cannot exceed 1000 characters!",
  ctrl_enter:
    "Press Ctrl + Enter to enter a new line, and press Enter to send.",
  account: "account",
  enterprise_code: "Enterprise Number",
  common_problem: "Frequently asked questions",
  join_the_organization: "Join an organization",
  complete: "Finish",
  unknown_error: "Unknown error",
  "404": "The requested address was not found (404)",
  the_day_before: "The day before yesterday",
  yesterday: "yesterday",
  just_now: "Just",
  sunday: "Sunday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
};

export default language;
